import type { AppType } from "@cafe/api/app-type";
import { hc } from "hono/client";

/** End-to-end typed client for the Hono API (types come straight from the route definitions). */
export const api = hc<AppType>("/", { init: { credentials: "same-origin" } }).api;

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
  ) {
    super(message);
  }
}

type ErrorBody = { error: { code: string; message: string } };
type JsonOf<R> = R extends { json(): Promise<infer T> } ? T : never;

/** Unwrap a Hono client response: typed JSON on success, ApiError with the API's Spanish message otherwise. */
export async function unwrap<R extends { ok: boolean; status: number; json(): Promise<unknown> }>(res: R): Promise<Exclude<JsonOf<R>, ErrorBody>> {
  const body = (await res.json().catch(() => ({}))) as Partial<ErrorBody>;
  if (!res.ok) {
    throw new ApiError(res.status, body?.error?.code ?? "error", body?.error?.message ?? "Algo salió mal. Intenta de nuevo.");
  }
  return body as Exclude<JsonOf<R>, ErrorBody>;
}
